import React from "react"
import axios from 'axios'
import $ from "jquery";
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCTabBar } from '@material/tab-bar';
import Slider from '@material-ui/core/Slider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const defaultBtnLabel = <div><i className="fas fa-search" aria-hidden="true" style={{ marginRight: "6px" }}></i> Найти за 3$</div>
const waitingBtnLabel = <CircularProgress classes={{ root: "tmbtn" }} />

class TeleSearchPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: "",
      error: null,
      isLoaded: false,
      items: [],
      selected: {},
      open: false,
      btn_label: defaultBtnLabel
    }
  }


  snackbarOpen = (message) => {
    this.setState({ open: true, message })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ open: false })
  }

  setSelected(selected) {
     return this.setState({ selected })
  }

  handleClick = (event) => {
    this.setState({ btn_label:  waitingBtnLabel})

    axios.post("https://nakrutkatop.com:443/api/ts/search", {user: this.state.user.trim()},{ withCredentials: true })
      .then(res => {
        this.setState({ btn_label:  defaultBtnLabel})
        if (!res.data.ok) return this.snackbarOpen(res.data.descr)
        this.snackbarOpen("Данные получены!")
        this.setState({selected: res.data.res, user: ""})
        this.loadHistory()
        this.props.updateBalance()
      })
      .catch(e=>{
        this.setState({ btn_label:  defaultBtnLabel})
         return this.snackbarOpen("Ошибка соединения")
      })
  }


  loadHistory() {
    axios.get("https://nakrutkatop.com:443/api/ts/history", { withCredentials: true }).then(res => {res.data.ok && this.setState({isLoaded: true, items: res.data.history})})
  } 

  componentDidMount() {
    this.loadHistory()
  }

  render(props) {
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <div className="page_wrap" ng-view style={{ maxWidth: "0px", maxHeight: "0px", opacity: 0, display: "none" }}></div>
      <div id="notify_sound"></div>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        message={this.state.message}
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={this.handleClose}>
              Закрыть
            </Button>

          </React.Fragment>
        }
      />
      <main className="main-content custom-scrollbar" id="main-content">

        <h2 className="pageHeader"> <i className="fas fa-search mdc-list-item__graphic fa-lg" aria-hidden="true" style={{ color: "#fff", marginRight: "40px" }}></i>TeleSearch</h2>

        <div className="irow center-align-row" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
            <h3 className="ibox_title"><div><i class="fas fa-info" aria-hidden="true" style={{ marginRight: "8px" }}></i> Информация</div>  <div>
            </div></h3>
            <div className="ibox_content full-height acc-status-table" style={{ padding: "16px", paddingTop: "0px", marginLeft: "0px" }}>
              С помощью этого сервиса Вы сможете получить список публичных чатов, в которых состоит пользователь мессенджера Telegram
              <table cellspacing="0" style={{marginTop: "8px"}}>
            <tr >
              <td className="acc-status-table-left" ><i class="fas fa-comments" aria-hidden="true" style={{ marginRight: "8px" }}></i>Чатов проиндексировано</td><td className="acc-status-table-right">532 348</td>
            </tr>
            <tr>
              <td className="acc-status-table-left"><i class="fas fa-users" aria-hidden="true" style={{ marginRight: "8px" }}></i>Пользователей найдено</td><td className="acc-status-table-right">102 087 928</td>
            </tr>
         
          </table>
                </div>
          </div>


          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
            <h3 className="ibox_title"><div><i class="fas fa-search" aria-hidden="true" style={{ marginRight: "8px" }}></i> Запрос</div>  <div>
            </div></h3>
            <div className="ibox_content full-height" style={{ padding: "8px", display: "inline-block" }}>
              <FormControl variant="outlined" classes={{ root: "ltb half" }}>
                <InputLabel htmlFor="outlined-basic">ID или юзернейм</InputLabel>
                <OutlinedInput id="outlined-basic" label="ID или юзернейм" variant="outlined" value={this.state.user} onChange={(event) => this.setState({ user: event.target.value })} />
              </FormControl>

              <Button variant="contained" onClick={this.handleClick} classes={{ root: "rtb half mdbtn" }} style={{ height: "54px" }}>{this.state.btn_label}</Button>
              <div className="acc-status-table" style={{ textAlign: "center", marginLeft: "0px", paddingTop: "4px", paddingBottom: "4px"}}>
              <i class="fas fa-check" aria-hidden="true" style={{ marginRight: "8px" }}> </i>Средства будут списаны только за успешный поиск
                </div>
            </div>
          </div>

        </div>

        <div className="irow center-align-row" style={{ display: "flex", flexWrap: "wrap" }}>
          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", margin: "8px", opacity: "1", transition: ".3s opacity, .3s visibility" }} id="paramsBox">
            <h3 className="ibox_title"><div><i class="fas fa-poll-h" aria-hidden="true" style={{ marginRight: "8px" }}></i> Результат</div>

            </h3>
            <div className="ibox_content" style={{ padding: "8px" }}>
              <div>
                <FormControl variant="outlined" classes={{ root: "third third-left" }}>
                  <InputLabel htmlFor="outlined-basic">ID</InputLabel>
                  <OutlinedInput id="outlined-basic" label="ID" variant="outlined" value={this.state.selected.id || ""} />
                </FormControl>

                <FormControl variant="outlined" classes={{ root: "third third-middle" }}>
                  <InputLabel htmlFor="outlined-basic">Юзернейм</InputLabel>
                  <OutlinedInput id="outlined-basic" label="Юзернейм" variant="outlined" value={this.state.selected.username || ""} />
                </FormControl>

                <FormControl variant="outlined" classes={{ root: "third third-right" }}>
                  <InputLabel htmlFor="outlined-basic">Имя</InputLabel>
                  <OutlinedInput id="outlined-basic" label="Имя" variant="outlined" value={this.state.selected.name || ""} />
                </FormControl>

                <FormControl variant="outlined" classes={{ root: "full last-element" }}>
                  <InputLabel htmlFor="outlined-basic">Чаты</InputLabel>
                  <OutlinedInput id="outlined-basic" label="Чаты" variant="outlined" multiline rows={7} rowsMax={7} value={this.state.selected.chats || ""} classes={{root: "custom-scrollbar"}}/>
                </FormControl>
              </div>
            </div>
          </div>

          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
            <h3 className="ibox_title"><div><i class="fas fa-list-ul" aria-hidden="true" style={{ marginRight: "8px" }}></i> История</div>  <div>
            </div></h3>
            <div className="ibox_content full-height custom-scrollbar" style={{ padding: "0", marginRight: "4px", maxHeight: "257px", overflowY: "auto" }}>
            {this.state.isLoaded ? 
              <List component="nav" aria-label="main mailbox folders" style={{marginTop: "-8px"}}>
                  {this.state.items.map(req=><ListItem button onClick={()=>{this.setSelected(req)}}>
                    <ListItemIcon style={{minWidth: "36px", width: "40px", paddingTop: "6px"}}>
                      <i className={"mdc-list-item__graphic fas fa-lg fa-user-alt"} style={{fontSize: "24px"}}></i>
                    </ListItemIcon>
                    <ListItemText primary={req.username || req.name} />
                  </ListItem>)}
                  </List>
              : <CircularProgress />}
            </div>
          </div>
        </div>

      </main>
    </div>
  }
}
//   <SIMRentParams state={this.state} />
export default TeleSearchPage
//Настройки рассылки
const prices = [0, 50, 100, 200, 300, 400]
const types = [
  "Рассылка по чатам",
  "Рассылка по пользователям",
  "Инвайтинг в чат",
]